import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { DepartureCommittedSearch } from '~/components/Cruises/components/shared/DepartureGridConfig';

import departureService from '~/services/cruises/DepartureService';

import { departureQueryKeys } from './departureQueryKeys';

export const DEPARTURE_PAGE_SIZE = 25;

export interface DepartureSort {
  sortBy?: 'shipName' | 'departureDate';
  sortDirection?: 'asc' | 'desc';
}

export function buildDepartureListParams(
  committedSearch: DepartureCommittedSearch,
  page: number,
  pageSize = DEPARTURE_PAGE_SIZE,
  sort: DepartureSort = {},
) {
  return {
    vendorId: committedSearch.vendorId,
    name: committedSearch.name || undefined,
    shipName: committedSearch.shipName || undefined,
    departureDateStart: committedSearch.departureDateStart || undefined,
    departureDateEnd: committedSearch.departureDateEnd || undefined,
    sailingDurationMin: committedSearch.sailingDurationMin ? Number(committedSearch.sailingDurationMin) : undefined,
    sailingDurationMax: committedSearch.sailingDurationMax ? Number(committedSearch.sailingDurationMax) : undefined,
    status: committedSearch.status || undefined,
    offerId: committedSearch.offerId || undefined,
    sailingExternalId: committedSearch.sailingExternalId ? Number(committedSearch.sailingExternalId) : undefined,
    shipExternalId: committedSearch.shipExternalId ? Number(committedSearch.shipExternalId) : undefined,
    departurePortExternalIds: committedSearch.departurePortExternalIds.length
      ? committedSearch.departurePortExternalIds
      : undefined,
    skip: page * pageSize,
    take: pageSize,
    ...sort,
  };
}

export function useGetDepartures(
  committedSearch: DepartureCommittedSearch | null,
  page: number,
  pageSize = DEPARTURE_PAGE_SIZE,
  sort: DepartureSort = {},
) {
  return useQuery({
    queryKey: departureQueryKeys.list(committedSearch, page, pageSize, sort),
    queryFn: () => {
      if (!committedSearch) {
        throw new Error('committedSearch is required');
      }
      return departureService.listWithPagination(buildDepartureListParams(committedSearch, page, pageSize, sort));
    },
    enabled: !!committedSearch,
    placeholderData: keepPreviousData,
  });
}
